/**
 * علامة GoyOne.
 *
 * الأبعاد مأخوذة من ملف الهوية البصرية كما هي، فتتطابق النسب مع النسخ
 * المطبوعة. رسمها كـ SVG لا كصورة يجعلها حادة في كل مقاس ويسمح بتلوينها
 * من الرموز، فتتبع الوضع الليلي دون ملف ثانٍ.
 */
export function Logo({ size = 28, mono = false }: { size?: number; mono?: boolean }) {
  const arc = mono ? 'currentColor' : 'var(--brand)';
  const dot = mono ? 'currentColor' : 'var(--accent-600)';
  const stem = mono ? 'currentColor' : 'var(--brand)';

  return (
    <svg
      viewBox="304 315 547 606"
      width={size}
      height={size}
      role="img"
      aria-label="GoyOne"
      style={{ display: 'block' }}
    >
      <path
        d="M607 331 A287 287 0 0 0 607 905 L607 816 A198 198 0 0 1 607 420 Z"
        fill={arc}
      />
      <circle cx="733.5" cy="494.5" r="57.5" fill={dot} />
      <path d="M604 573 H835 V816 H745 V663 H604 Z" fill={stem} />
    </svg>
  );
}
